// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Admin } from './admin';
import { Bonding } from './bonding';
import { Insurer } from './insurer';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Bond extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  bondId!: number;
  adminId!: number;
  asAtDate?: Date;
  assetAsAtDate?: Date;
  assetValue!: number;
  bondValueFrom!: number;
  bondValueTo!: number;
  createdBy!: string;
  createdDate!: Date;
  insurerId?: number;
  reviewAssetValue!: number;
  reviewDate?: Date;
  saref?: string;
  startDate?: Date;
  submittedDate?: Date;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  userId!: number;
  admin!: Admin;
  bondings!: Bonding[];
  insurer!: Insurer;
  user!: User;
}

